import * as Configuration from '../../../../../app.constants.js';

subbotParam.$inject = ['$stateParams', 'MediasFactory', 'AlertingFactory', '$http', '$translate', '$sce'];
export function subbotParam($stateParams, MediasFactory, AlertingFactory, $http, $translate, $sce) {
  return {
    restrict: 'E',
    template: require('./subbot-param.directive.html'),
    scope: {
      model: '=',
      description: '<',
      subBotName: '<',
      mode: '<',
      applicationId: "<?",
      fileParam: '=',
      showSpinner: '='
    },
    require: '^form', // https://stackoverflow.com/questions/17618318/pass-form-to-directive
    link: link
  };

  function link(scope, element, attrs, formCtrl) {
    scope.fileValidity = true;
    scope.selectFileClicked = () => { 
      element.find('input[type="file"]').click();
    };
    scope.editSubbotForm = formCtrl;
    if (!scope.description.specification) {
      scope.description.specification = {};
    }
    initForSpecificTypes(scope);
    // Work around ng-ifs and ng-repeats creating child scopes 
    // (see e.g. https://stackoverflow.com/questions/18342917/angularjs-ng-model-doesnt-work-inside-ng-if )
    scope.directiveModel = {
      'value': scope.model
    };
    // But in addition we need to forward any new value up to our parent scope 
    // (angular watches scope.model because we declared it with '=' in the directive definition)
    scope.$watch("directiveModel.value", newValue => { 
      scope.model = newValue; 
    });
    scope.$watch("fileValidity", newValue => { 
      scope.fileParam.isValid = newValue; 
    });
  }
  
  
  function initForSpecificTypes(scope) {
    if (scope.description.type === 'string') {
      initForStringType(scope);
    }
    if (scope.description.type === 'integer') {
      initForIntegerType(scope);
    }
    if (scope.description.type === 'enum') {
      initForEnumType(scope);
    }
    if (scope.description.type === 'file') {
      initForFileType(scope);
    }
    if (scope.description.type === 'excel') {
      initForExcelFileType(scope);
    }
  }
  

  function validateMimeTypes(mimeTypes) {
    const acceptRE = /^[\w\s,\/*.+-]+$/;
    return acceptRE.test(mimeTypes);
  }
  
  function initForFileType(scope) {
    scope.selectedFile = { value: null };
    if (scope.description.specification && validateMimeTypes(scope.description.specification.mime_types)) {
      scope.acceptedFileTypes = scope.description.specification.mime_types;
    }
    scope.$watch('selectedFile.value', file => {
      if (file) {
        onFileSelected(scope, file);
      }
    });
  }

  function onFileSelected(scope, file) {
    scope.uploadingFileAttachment = true;
    scope.uploadProgress = 0;
    MediasFactory.upload2($stateParams.companyId, $stateParams.siteId, 'file', file,
      response => {
        scope.directiveModel.value = {
            fileId: response.data.file_id,
            fileName: file.name
        };
        scope.uploadingFileAttachment = false;
      },
      response => {
        AlertingFactory.error(response && response.data && response.data.error.reason.error ? response.data.error.reason.error : 'common/http_error');
        scope.uploadingFileAttachment = false;
      },
      percent => scope.uploadProgress = Math.round(percent));
  }


  function initForExcelFileType(scope) {
    scope.selectedFile = { value: null };
    if (scope.description.specification && scope.description.specification.mime_types && validateMimeTypes(scope.description.specification.mime_types)) {
      scope.acceptedFileTypes = scope.description.specification.mime_types;
    }
    else{ // pending mime type in excel file type spec
      scope.acceptedFileTypes = "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    }
    scope.$watch('selectedFile.value', file => {
      if (file) {
        onExcelFileSelected(scope, file);
      }
    });
  }
  

  function onExcelFileSelected(scope, file) {
    scope.uploadingFileAttachment = true;
    scope.uploadProgress = 0;
    scope.fileValidity = true;
    
    const data = {
      'subbotMode': scope.mode,
      'subbotName': scope.subBotName,
      'fileName': file.name,
      'file': file,
      'parameterType': scope.description.type,
      'parameterName': scope.description.name,
      'applicationId': scope.applicationId,
    };
    scope.showSpinner.value = true;
    MediasFactory.uploadSubbotExcel($stateParams.companyId, $stateParams.siteId, data,
      response => {
        scope.directiveModel.value = {
          fileId: response.data.file_id,
          fileName: file.name
        };

        scope.uploadingFileAttachment = false;

        if (!!response.data.links) {
          const href = response.data.links.href;
          const httpMethod = response.data.links.type;
          const url = Configuration.constants.baseUrl + 'api/1.0/companies/' + $stateParams.companyId + '/sites/' + $stateParams.siteId + href;
          return MediasFactory.afterUploadSubbotExcel($stateParams.companyId, url, httpMethod).then(
            (afterUploadResponse) => {
              const body = afterUploadResponse.data;
            }, (errorResponse) => {
              AlertingFactory.error('subbot/file-upload/post-action-failed')
            }
          ).finally(() => scope.showSpinner.value = false);
        } else {
          scope.showSpinner.value = false;
        }
      },
      response => {
        scope.directiveModel.value = {
          fileId: null,
          fileName: file.name
        };

        let placeHoldersBeautified = {};
        for (let placeHolder in response.data.error.error_message_place_holders) {
          placeHoldersBeautified[placeHolder] = `<strong>${response.data.error.error_message_place_holders[placeHolder]}</strong>`;
        }

        let errorMessage = $translate.instant(response.data.error.error_message_translation_key, placeHoldersBeautified);
        scope.fileErrors = $sce.trustAsResourceUrl(errorMessage);

        scope.uploadingFileAttachment = false;
        scope.fileValidity = false;
        scope.showSpinner.value = false;
      },
      percent => scope.uploadProgress = Math.round(percent));
  }


  function initForEnumType(scope) {
    if (!scope.description.specification.values) {
      scope.description.specification.values = [];
    }
    scope.enumDropdownItems = scope.description.specification.values.map(
      value => ({
        id: value,
        label: value
      })
    );
  }
  
  
  function initForIntegerType(scope) {
    scope.maybeIntegerRegExp = new RegExp('^(-|\\+)?[0-9]+$');
  }
  
  
  function initForStringType(scope) {
    if (scope.description.specification.regexp) {
      scope.stringSpecRegExp = new RegExp(scope.description.specification.regexp);
      if (!scope.stringSpecRegExp.test('')) {
        // Angularjs allows an empty string even when the pattern doesn't, let's work around this
        scope.isStringRequired = true;
      }
    }
  }
}

